module.exports = __webpack_public_path__ + "media/images/v1/overlay-642639dd734883f2a3876f80418d07a7.png";